export default {"src":"/_next/static/media/situation-other.6b753d7d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};